module.exports = __webpack_public_path__ + "static/media/reactredux.782e20f8.png";